import React from 'react';
import { Link } from 'react-router-dom';
import Subscribe from './Subscribe';
import '../css/pages/SponsorsLockedPreview.css';

// What a logged-in user without an active subscription sees at /sponsors/:
// the subscribe card, nothing else, plus a way to try the free tools first.
// (This used to be a masked teaser grid with locked filters — the free
// preview at /niche/all covers that job now, so this page just converts.)
const SponsorsLockedPreview: React.FC = () => (
    <Subscribe userAuth={true} isSubscribed={false}>
        <p className="locked-preview__tools-link">
            Want a look first? <Link to="/tools/">Try our free tools</Link>
        </p>
    </Subscribe>
);

export default SponsorsLockedPreview;
